<template>
  <div id="pageContent" >
    <div id="formArea"  class="borderBox" >
      <div v-if="demandDenied"><p style="color:red">Клиенту в заявке отказано</p></div>
      <div id="quest" v-else>

        <div v-if="parseInt(getDemandIdMsg, 10) > 0">
          <div id="step1" v-if="curentStep=='step1'">
            <p>Какой тип телефона у клиента?</p>
            <div id="step1InputWrap">
              <label>
                <input type="radio" v-model="phoneType" value="ios">
                <span>ios</span>
              </label>
              <label>
                <input type="radio" v-model="phoneType" value="android">
                <span>android</span>
              </label>
            </div>
            <button v-on:click="step1">Далее</button>
          </div>
          <div id="step2ios" v-if="curentStep == 'step2ios'">
            <ios></ios>
            <button v-on:click="backStep1">Изменить тип телефона у клиента</button>
          </div>
          <div id="step2android"  v-if="curentStep == 'step2android'">
            <android></android>
            <button v-on:click="backStep1">Выбрать другое устройство</button>
          </div>
          <div v-if="curentStep == 'loading'"><p>Идет загрузка</p></div>
        </div>
        <div v-else>
          <p>Необходимо дождаться получения номера заявки</p>
        </div>
      </div>

      <button v-on:click="prevPage">Завершить и вернуться к обзвону</button>
      <div class="loaderWrap" v-if="loading">
        <loader ></loader>
      </div>
    </div>
    <div class="borderBox" id="operatorScript">
      <div >
        <formInput :refs="'PHONE'" :form="'request'"></formInput>
        <p>ID заявки: {{getDemandIdMsg}}</p>
        <p>Статус заявки: {{getDemandStatusMsg}}</p>
      </div>
      <div v-if="smsSend">
        <p>На номер клиента отправленна смс с ссылкой на приложение.</p>
        <smsInfo v-on:repeatSms="sendInviteSms"></smsInfo>
      </div>
      <div v-else>
        <p>Для отправки смс нужно выбрать тип телефона</p>
      </div>

    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  export default {
    name: "videoScoring",
    data(){
      return {
        curentStep:'step1',
        loading:false,
        phoneType:'',
        smsSend:false,
        iosUrl: '',
        errMsg: '',
      }
    },
    components: {
      formInput: () => import('@/components/forms/formInput'),
      loader: () => import('@/components/loader'),
      ios:()=>import('@/components/videoScoring/ios'),
      android:()=>import('@/components/videoScoring/android'),
      smsInfo:()=>import('@/components/OperatorScript/smsInfo'),
    },
    methods:{
      prevPage(){
        this.$router.go(-1);
      },
      getDemand(){
        return new Promise((resolve, reject) => {
          if (this.vdscr.demandRequestGuid.length > 0) {
            console.log(this.vdscr.demandRequestGuid)
            this.$myApi.GetRequestResult(this.vdscr.demandRequestGuid,this)
            .then(res=>{
              this.$store.dispatch('saveDemand',res[0].Demid)
              .then(()=>{ resolve();})
              .catch(()=>{ reject();});
            }).catch(res=>{
              res['ads']='';
              reject();
            });
          } else {
            reject();
          }
        });
      },
      getStatus(){
        return new Promise((resolve, reject) => {
          console.log('getSTatus')
         this.$myApi.SendRequest({
           action:'Operator_getStatusDemand',
           demand:this.vdscr.demandId
         }, this).then(res=>{
           this.$store.dispatch('saveStatusDemand',res[0].Stat);
           if (res[0].Stat != 'Отказано' && res[0].Stat != 'Передана ПМ'){
               this.getStatus();
           } else {
             resolve();
           }

         }).catch(res=>{
           //заявка еще не сохранилось до статуса
           if (res.Response.ExecutionError.ExecutionErrorCode == 1) {
             this.getStatus().then(()=>{resolve()}).catch(()=>{reject()});
           }
           res['a']='a';
           reject()
         });
        });
      },
      createConf() {
        return new Promise((resolve, reject) => {
          if (this.iosUrl != ''){
            resolve();
            return false;
          }
          this.$myApi.singleRequest({
            action: 'trueconf_createConf',
            demand: this.getDemandIdMsg,
          }).then((res) => {
            this.iosUrl = res.url;
            resolve();
          }).catch((res) => {
            console.log('cath');
            console.log(res);
            this.errMsg = 'невозможно создать конференцию';
            reject();
          })
        });
      },
      sendInviteSms() {
        return new Promise((resolve, reject) => {
          this.$myApi.SendRequest({
            action:'trueconf_smsInviteVideoConf',
            Phone:this.valueVuex,
            Type:this.phoneType,
            Link:this.iosUrl,
            Demand: this.getDemandIdMsg,
          }, this).then((res)=>{
            res['a']='a';
            this.smsSend = true;
            alert('смс успешно отправлена на номер '+ this.valueVuex);
            resolve();
          }).catch((res)=>{
            res['a']='a';
            alert('ошибка отправки смс');
            reject();
          });
        });
      },
      step1(){
        if (this.phoneType != ''){
          this.curentStep = 'loading';
          this.createConf()
          .then(this.sendInviteSms)
          .then(() => {
            this.curentStep = 'step2' + this.phoneType;
          })
          .catch(() => {
            alert(this.errMsg);
            this.curentStep = 'step1'
          }).finally(()=>{
            this.confSmsLoading = false;
          });
        }
      },
      backStep1(){
        this.curentStep = 'step1';
      }
    },
    computed:{
      ...mapState({
        vdscr:state=>state.requestField.videoScoring,
        valueVuex: state => state.requestField.sendData.request.PHONE,
      }),
      ...mapGetters(['getDemandStatusMsg','getDemandIdMsg']),
      demandDenied(){
        return this.getDemandStatusMsg == 'Отказано' || this.getDemandStatusMsg == 'Отказано. Есть активная заявка'
          || this.getDemandStatusMsg == 'Отказано. Есть непогашенный займ' || this.getDemandStatusMsg == 'Клиент отказался';
      }
    },
    mounted(){
      localStorage.setItem('leadInfo', '');
      localStorage.removeItem('leadInfoTimeUpdate');


      this.getDemand()
        .then(this.getStatus)
        .then(()=>console.log('zbs'))
        .catch(()=>alert('Ошибка'))
        .finally(()=>{

        });
    }
  }
</script>

<style scoped>
  #pageContent{text-align: left;}
  #operatorScript{    margin: 0;
    width: calc(100% - 1070px);
    text-align: left;
    position: fixed;
    top: 10px;
    right: 10px;
    height: calc(100vh - 40px);
    overflow-x: scroll;}
  #pageContent{display: flex;align-items: flex-start;justify-content: flex-start;width: 100%;}
  #formArea{width: 900px;}
  #step1InputWrap{display: flex;}
  #step1InputWrap label{width: 100px;display: flex;align-items: center;justify-content: space-between;margin-right:
    10px;border: 1px solid #42b983;padding: 5px;}
  button{margin: 5px 0;}

  @media screen and (max-width: 1600px) {
    #pageContent{
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
    }
    #operatorScript{
      margin: 10px 0 10px 90px;
      width: 900px;
      position: relative;
      top:0;
      right:0;
      height: auto;
      overflow: inherit;
    }
  }
</style>
